/* raw layout hash: _operational-sla-maintenance-dashboard-layout:5be2e2f53234d84d6648fd920d1e18863b418db0beb5161879f085d1c5b587a3 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_operational-sla-maintenance-dashboard-layout" — renders its page content through the router outlet.
export default function OperationalSlaMaintenanceDashboardLayout() {
  return <AppShell layoutName="_operational-sla-maintenance-dashboard-layout" menu={LAYOUT_MENUS['_operational-sla-maintenance-dashboard-layout']} />;
}
